import * as asana_trigger from './asana-trigger';
import * as asana_webhook_trigger from './asana-webhook-trigger';
import * as chat_trigger from './chat-trigger';
import * as error_trigger from './error-trigger';
import * as execute_workflow from './execute-workflow';
import * as manual_trigger from './manual-trigger';
import * as mcp_trigger from './mcp-trigger';
import * as microsoft_outlook_trigger from './microsoft-outlook-trigger';
import * as polling_trigger from './polling-trigger';
import * as schedule_trigger from './schedule-trigger';
import * as webhook_trigger from './webhook-trigger';

export const triggersNodes = {
  'asana-trigger': asana_trigger,
  'asana-webhook-trigger': asana_webhook_trigger,
  'chat-trigger': chat_trigger,
  'error-trigger': error_trigger,
  'execute-workflow': execute_workflow,
  'manual-trigger': manual_trigger,
  'mcp-trigger': mcp_trigger,
  'microsoft-outlook-trigger': microsoft_outlook_trigger,
  'polling-trigger': polling_trigger,
  'schedule-trigger': schedule_trigger,
  'webhook-trigger': webhook_trigger,
};
